import React from 'react'
import classnames from 'classnames/bind'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const Icon = ({ isOpen }) => {
  return (
    <svg
      className={cx(css.Icon, { isOpen })}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={css.circle}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12.877C0 5.76524 5.76524 0 12.877 0C19.9856 0.00774566 25.7463 5.76845 25.7541 12.877C25.7541 19.9888 19.9888 25.7541 12.877 25.7541C5.76524 25.7541 0 19.9888 0 12.877ZM2.27829 17.2627C4.05368 21.5498 8.23687 24.3451 12.877 24.3451V24.3486C19.2102 24.3428 24.3428 19.2102 24.3486 12.877C24.3501 8.23687 21.556 4.05282 17.2695 2.27613C12.9829 0.49943 8.0482 1.48003 4.76661 4.76061C1.48502 8.04119 0.502912 12.9756 2.27829 17.2627Z"
      />
      <path
        className={css.minus}
        d="M12.1743 12.1743H7.07971V13.5797H12.1743H13.5797H18.6743V12.1743H13.5797H12.1743Z"
      />
      <path
        className={css.plus}
        d="M13.5797 7.07971H12.1743V12.1743H7.07971V13.5797H12.1743V18.6743H13.5797V13.5797H18.6743V12.1743H13.5797V7.07971V7.07971Z"
      />
    </svg>
  )
}

export default Icon
